import React from "react";

export type CheckboxProps = {
  checked?: boolean;
  onChange?: () => void;
};

export const Checkbox = ({ checked, onChange }: CheckboxProps) => {
  return (
    <div className="gpc__checkbox">
      <input type="checkbox" checked={checked} onChange={onChange} />
    </div>
  );
};
